/* global __APP_VERSION__ */
import { Box, Typography } from "@mui/material";
import YapiLogo from "@assets/svgs/footers/yapi-footer-logo.svg";
import {
  footerContainer,
  footerTextContainer,
  footerVersionContainer,
  footerVersion,
  footerText,
  logoStyle,
} from "./MainFastrFooterStyles";

export const MainFastrFooter = () => {
  const version = __APP_VERSION__ ? `v${__APP_VERSION__}` : "Unknown version";

  return (
    <>
      <Box sx={footerContainer}>
        <Box sx={footerVersionContainer}>
          <Box sx={footerTextContainer}>
            <Typography sx={footerText}>Powered by</Typography>
            <Box
              component="img"
              src={YapiLogo}
              alt="Yapi Logo"
              sx={logoStyle}
            />
          </Box>
          <Typography sx={footerVersion}>{version}</Typography>
        </Box>
      </Box>
    </>
  );
};
